import { render, staticRenderFns } from "./PasteAnnotationWithLinkModal.vue?vue&type=template&id=54844f3e&scoped=true"
import script from "./PasteAnnotationWithLinkModal.vue?vue&type=script&lang=js"
export * from "./PasteAnnotationWithLinkModal.vue?vue&type=script&lang=js"
import style0 from "./PasteAnnotationWithLinkModal.vue?vue&type=style&index=0&id=54844f3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54844f3e",
  null
  
)

export default component.exports